import { render, staticRenderFns } from "./bookRepositoryIdx.vue?vue&type=template&id=6d9eca56&scoped=true&"
import script from "./bookRepositoryIdx.vue?vue&type=script&lang=js&"
export * from "./bookRepositoryIdx.vue?vue&type=script&lang=js&"
import style0 from "./bookRepositoryIdx.vue?vue&type=style&index=0&id=6d9eca56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9eca56",
  null
  
)

export default component.exports